import { Col, Row } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import BranchOfficesData from './BranchOfficesData';
import ChangeLogo from './ChangeLogo';
import EditRealEstateData from './EditRealEstateData';
import RealEstateData from './RealEstateData';
import SocialMedia from './SocialMedia';
import WidgetAPI from './WidgetAPI';
import WidgetMeli from './WidgetMeli';
import WidgetProjectStats from './WidgetProjectStats';
import WidgetStats from './WidgetStats';
// import AdvanceTable from 'components/common/usersTable/AdvanceTable';
// import AdvanceTableWrapper from 'components/common/usersTable/AdvanceTableWrapper';
// import { useEffect, useState } from 'react';
// import { userColumns } from '../../gestionarUsuarios/tables/usersColumns';
// import { UsersActions } from '../../gestionarUsuarios/tables/usersTable/UsersActions';
// import { getColabs } from 'redux/colabsSlice';

const RealEstate = () => {
  // * States
  const userLogged = useSelector(state => state.login.currentUser);
  // const dispatch = useDispatch();
  // const { realEstate } = useSelector(state => state.realEstate);
  // const colaboradores = useSelector(state => state.colabs.data);

  // const [colabList, setColabList] = useState();
  // const [switchNewUser, setSwitchNewUser] = useState(false);

  // const status = {
  //   pending: 'Pendiente',
  //   active: 'Activo',
  //   expired: 'Expirado',
  //   disabled: 'Deshabilitado'
  // };

  // * Life Cycle
  // useEffect(() => {
  //   realEstate?.id && dispatch(getColabs());
  // }, [realEstate]);

  // useEffect(() => {
  //   colaboradores &&
  //     setColabList(
  //       colaboradores?.map(colab => {
  //         return {
  //           firstName: colab.firstName,
  //           lastName: colab.lastName,
  //           email: colab.email,
  //           dni: colab.dni,
  //           status: status[colab.status],
  //           actions: (
  //             <UsersActions
  //               colab={colab}
  //               switchNewUser={switchNewUser}
  //               setSwitchNewUser={setSwitchNewUser}
  //             />
  //           )
  //         };
  //       })
  //     );
  // }, [colaboradores]);

  return (
    <Row className="g-3">
      {userLogged?.typeOfUser === 'cucicba' && (
        <>
          <Col xs={12} md={6} lg={6}>
            <WidgetMeli />
          </Col>

          <Col xs={12} md={6} lg={6}>
            <WidgetAPI />
          </Col>

          <Col xs={12} sm={6} lg={6}>
            <WidgetStats title="Propiedades" />
          </Col>
          <Col xs={12} sm={6} lg={6}>
            <WidgetProjectStats title="Emprendimientos" />
          </Col>
        </>
      )}

      {/* {userLogged?.typeOfUser === 'cucicba' && colabList && (
        <Col xs={12}>
          <Card className="bg-white">
            <Card.Header className="border-bottom">
              <Card.Title>Listado de Usuarios</Card.Title>
            </Card.Header>

            <Card.Body>
              <AdvanceTableWrapper
                columns={userColumns}
                data={colabList}
                sortable
                pagination
                perPage={10}
              >
                <AdvanceTable
                  table
                  headerClassName="bg-200 text-nowrap align-middle"
                  rowClassName="align-middle text-black"
                  tableProps={{
                    bordered: true,
                    striped: true,
                    className: 'fs--1 mb-0 overflow-hidden border-light'
                  }}
                />
              </AdvanceTableWrapper>
            </Card.Body>
          </Card>
        </Col>
      )} */}

      <Col xs={12} md={6} lg={4}>
        <Row className="g-3">
          <Col xs={12}>
            <ChangeLogo />
          </Col>

          <Col xs={12}>
            {userLogged?.typeOfUser !== 'cucicba' ? (
              <RealEstateData />
            ) : (
              <EditRealEstateData />
            )}
          </Col>

          <Col xs={12}>
            <SocialMedia />
          </Col>
        </Row>
      </Col>

      <Col xs={12} md={6} lg={8}>
        <BranchOfficesData />
      </Col>
    </Row>
  );
};

export default RealEstate;
